import { useState, useEffect, useCallback } from "react";
import { Back2 } from "../../components/Option/Back";
import ProductVariationEditor from "./ProductVariationEditor";
import ProductBar from "../NewProduct/components/ProductBar";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import {
  getProductDetail,
  updateProduct,
  deleteProduct,
} from "../../apis/Product";
import { getSubgroupProductList } from "../../apis/Product";
import EditableProductComponent from "../NewProduct/components/ProductComponentBox/EditableProductComponent";
import "./index.css";
import "./product-detail-pcf-theme.css";
import { ProductIntro } from "./ProductIntro";
import { useUserAccess } from "../../components/WriteAccessContext";
import Delete from "../../components/Option/Delete";
import { AlertV2 } from "../../components/Alert";
import { useTranslation } from "react-i18next";
import saveIcon from "../../assets/new_product_detail/save-icon.svg";
import { ProductCertificatesAutocomplete } from "./ProductCertificatesAutocomplete";
import { ProductNormalInput } from "./ProductNormalInput";
import { ProductMultipleInputs } from "./ProductMultipleInputs";
import MaterialBreakdownPie from "./ProductLCAPie/MaterialBreakdownPie";
import PercentageBreakdownPie from "./ProductLCAPie/PercentageBreakdownPie";
import WeightCategoryPie from "./ProductLCAPie/WeightOfMaterialsCategorized";
import PercentageCategoryPie from "./ProductLCAPie/PercentageCategoryPie";
import ProductImages from "./ProductImages";
import { getLocationDropdownLCA } from "../../apis/Bonsai/locationDropdownApi";
import { useProductCatalogTabContext } from "../Product/ProductCatalogTabContext";

export const NewProductDetail = ({ showCategory, hideDelete = false }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let { productId } = useParams();
  const business = queryParams.get("business");

  const [subgroups, setSubgroups] = useState([]);
  const [variations, setVariations] = useState([]);
  const [certificates, setCertificates] = useState([]);
  const [countryOrigin, setCountryOrigin] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [name, setName] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [soldToCustomer, setSoldToCustomer] = useState("");
  const [productNum, setProductNum] = useState("");
  const [unit, setUnit] = useState("");
  const [leasedToCustomer, setLeasedToCustomer] = useState("");
  const [takeBackCustomer, setTakeBackCustomer] = useState("");
  const [totalProductsSold, setTotalProductsSold] = useState("");
  const [soldUnit, setSoldUnit] = useState("");
  const [totalProductsLeased, setTotalProductsLeased] = useState("");
  const [totalProductsTakeback, setTotalProductsTakeback] = useState("");
  const [leasedUnit, setLeasedUnit] = useState("");
  const [salesShare, setSalesShare] = useState("");
  const [individualProduct, setIndividualProduct] = useState("");
  const [individualProductPackaging, setIndividualProductPackaging] =
    useState("");
  const [finalWeight, setFinalWeight] = useState(0);
  const [functionalUnitNum, setFunctionalUnitNum] = useState(0);
  const [functionalUnit, setFunctionalUnit] = useState("");
  const [productData, setProductData] = useState(null);
  const { userAccess } = useUserAccess();
  const [subgroupId, setSubgroupId] = useState("");
  const [subgroupName, setSubgroupName] = useState("");
  const [deleteProductAlert, setDeleteProductAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [dropdownCountry, setDropdownCountry] = useState([]);
  const [lifetimeFunctional, setLifetimeFunctional] = useState();
  const [lifetimeFunctionalUnit, setLifetimeFunctionalUnit] = useState();
  const [functionalUnitDesc, setFunctionalUnitDesc] = useState();
  const [wasteWeight, setWasteWeight] = useState();
  const [totalWeight, setTotalWeight] = useState();
  const [wasteWeighIn, setWasteWeighIn] = useState();
  const [totalWeighIn, setTotalWeighIn] = useState();

  const handleDelete = () => {
    setDeleteProductAlert(true);
  };

  const navigate = useNavigate();
  const catalogTabCtx = useProductCatalogTabContext();
  const handleMove = useCallback(() => {
    if (catalogTabCtx?.goCatalog) {
      catalogTabCtx.goCatalog();
      return;
    }
    navigate("/product", { replace: true });
  }, [navigate, catalogTabCtx]);

  const handleUpdateVariations = (variationUpdate) => {
    setSubgroupId(variationUpdate.subgroup);
    setSubgroupName(variationUpdate.subgroupName);
    setVariations(variationUpdate.variation_categories);
  };

  useEffect(() => {
    if (window.location.href.includes("product")) {
      getProductDetail({
        id: productId,
        business: business,
        setCreatedAt: setCreatedAt,
        setName: setName,
        setSoldToCustomer: setSoldToCustomer,
        setProductNum: setProductNum,
        setUnit: setUnit,
        setLeasedToCustomer: setLeasedToCustomer,
        setTakeBackCustomer: setTakeBackCustomer,
        setTotalProductsSold: setTotalProductsSold,
        setSoldUnit: setSoldUnit,
        setTotalProductsLeased: setTotalProductsLeased,
        setTotalProductsTakeback: setTotalProductsTakeback,
        setLeasedUnit: setLeasedUnit,
        setSalesShare: setSalesShare,
        setIndividualProduct: setIndividualProduct,
        setIndividualProductPackaging: setIndividualProductPackaging,
        setFinalWeight: setFinalWeight,
        setVariationCategories: setVariations,
        setCertificates: setCertificates,
        setCountryOrigin: setCountryOrigin,
        setFunctionalUnit: setFunctionalUnit,
        setFunctionalUnitNum: setFunctionalUnitNum,
        setCountryCode: setCountryCode,
        setObjects: setProductData,
        setLifetimeFunctional: setLifetimeFunctional,
        setLifetimeFunctionalUnit: setLifetimeFunctionalUnit,
        setFunctionalUnitDesc: setFunctionalUnitDesc,
        setWasteWeighIn: setWasteWeighIn,
        setWasteWeight: setWasteWeight,
        setTotalWeighIn: setTotalWeighIn,
        setTotalWeight: setTotalWeight,
      });
    }
  }, [business, productId]);

  useEffect(() => {
    getSubgroupProductList({ setSubgroups: setSubgroups });
  }, []);

  useEffect(() => {
    getLocationDropdownLCA({
      setDropdownData: setDropdownCountry,
    });
  }, []);

  const handleCertificatesChange = (event, newValue) => {
    setCertificates(newValue);
  };

  const handleUpdateProduct = () => {
    updateProduct({
      id: productId,
      name: name,
      soldToCustomer: soldToCustomer,
      productNum: productNum,
      unit: unit,
      leasedToCustomer: leasedToCustomer,
      takeBackCustomer: takeBackCustomer,
      totalProductsSold: totalProductsSold,
      soldUnit: soldUnit,
      totalProductsLeased: totalProductsLeased,
      totalProductsTakeback: totalProductsTakeback,
      leasedUnit: leasedUnit,
      salesShare: salesShare,
      individualProduct: individualProduct,
      individualProductPackaging: individualProductPackaging,
      finalWeight: finalWeight,
      business: business,
      variationCategories: variations,
      certificates: certificates,
      countryOrigin: countryOrigin,
      functionalUnit: functionalUnit,
      functionalUnitNum: functionalUnitNum,
      countryCode: countryCode,
      lifetimeFunctional: lifetimeFunctional,
      lifetimeFunctionalUnit: lifetimeFunctionalUnit,
      functionalUnitDesc: functionalUnitDesc,
      setErrorMessage: setErrorMessage,
      callback: () => {
        getProductDetail({
          id: productId,
          business: business,
          setCreatedAt: setCreatedAt,
          setName: setName,
          setSoldToCustomer: setSoldToCustomer,
          setProductNum: setProductNum,
          setUnit: setUnit,
          setLeasedToCustomer: setLeasedToCustomer,
          setTakeBackCustomer: setTakeBackCustomer,
          setTotalProductsSold: setTotalProductsSold,
          setSoldUnit: setSoldUnit,
          setTotalProductsLeased: setTotalProductsLeased,
          setTotalProductsTakeback: setTotalProductsTakeback,
          setLeasedUnit: setLeasedUnit,
          setSalesShare: setSalesShare,
          setIndividualProduct: setIndividualProduct,
          setVariationCategories: setVariations,
          setCountryOrigin: setCountryOrigin,
          setCountryCode: setCountryCode,
          setLifetimeFunctional: setLifetimeFunctional,
          setLifetimeFunctionalUnit: setLifetimeFunctionalUnit,
          setFunctionalUnitDesc: setFunctionalUnitDesc,
          setWasteWeighIn: setWasteWeighIn,
          setWasteWeight: setWasteWeight,
          setTotalWeighIn: setTotalWeighIn,
          setTotalWeight: setTotalWeight,
        });
      },
    });
  };

  const dataCountry = [
    {
      name: `${t("COUNTRY_MANUFACTURING_ASSEMBLY")}`,
      value: countryOrigin,
      setValue: setCountryOrigin,
      isDropdown: true,
      options: dropdownCountry,
      secondData: "code",
      setSecondData: setCountryCode,
    },
    {
      name: `${t("Lifetime of functional unit")}`,
      value: lifetimeFunctional,
      setValue: setLifetimeFunctional,
      isDropdown: false,
    },
    {
      name: `${t("Unit")}`,
      value: lifetimeFunctionalUnit,
      setValue: setLifetimeFunctionalUnit,
      isDropdown: true,
      options: [
        { value: t("Use"), label: t("Use") },
        { value: t("Years"), label: t("Years") },
        { value: t("Days"), label: t("Days") },
        { value: t("Hours"), label: t("Hours") },
      ],
    },
  ];
  const dataIsProduct = [
    {
      name: `${t("SOLD")} (Amount)`,
      value: soldToCustomer,
      setValue: setSoldToCustomer,
      isDropdown: false,
    },
    {
      name: `${t("LEASED")} (Amount)`,
      value: leasedToCustomer,
      setValue: setLeasedToCustomer,
      isDropdown: false,
    },
    {
      name: `${t("Take back")} (Amount)`,
      value: takeBackCustomer,
      setValue: setTakeBackCustomer,
      isDropdown: false,
    },
  ];

  const dataQtyFUSLT = [
    {
      name: `${t("SOLD")}`,
      value: totalProductsSold,
      setValue: setTotalProductsSold,
      isDropdown: false,
    },
    {
      name: `${t("LEASED")}`,
      value: totalProductsLeased,
      setValue: setTotalProductsLeased,
      isDropdown: false,
    },
    {
      name: `${t("Take back")}`,
      value: totalProductsTakeback,
      setValue: setTotalProductsTakeback,
      isDropdown: false,
    },
  ];

  const dataFunctionalUnit = [
    {
      name: `${t("AMOUNT")}`,
      value: functionalUnitNum,
      setValue: setFunctionalUnitNum,
      isDropdown: false,
    },
    {
      name: `Unit`,
      value: functionalUnit,
      setValue: setFunctionalUnit,
      isDropdown: true,
      options: [
        { value: t("STK"), label: t("STK") },
        { value: t("M2"), label: t("M2") },
        { value: t("M3"), label: t("M3") },
        { value: t("TONS"), label: t("TONS") },
        { value: t("KG"), label: t("KG") },
      ],
    },
    {
      name: `What is it?`,
      value: functionalUnitDesc,
      setValue: setFunctionalUnitDesc,
      isDropdown: false,
      type: "text",

      isTextArea: true,
    },
  ];

  const dataSaleShare = [
    {
      name: `(%)`,
      value: salesShare,
      setValue: setSalesShare,
      isDropdown: false,
    },
  ];

  const dataIndividualProduct = [
    {
      name: `kg`,
      value: individualProduct,
      setValue: setIndividualProduct,
      isDropdown: false,
      secondValue: wasteWeight,
      setSecondValue: setWasteWeight,
      thirdValue: totalWeight,
      setThirdValue: setTotalWeight,
    },
  ];

  const dataWeighIn = [
    {
      name: `kg`,
      value: finalWeight,
      setValue: setFinalWeight,
      isDropdown: false,
      secondValue: wasteWeighIn,
      setSecondValue: setWasteWeighIn,
      thirdValue: totalWeighIn,
      setThirdValue: setTotalWeighIn,
    },
  ];

  const dataWeightIndividualProduct = [
    {
      name: `kg`,
      value: individualProductPackaging,
      setValue: setIndividualProductPackaging,
      isDropdown: false,
    },
  ];

  return (
    <div className="product-detail-bg pcf-edit-product">
      {catalogTabCtx?.goCatalog ? (
        <button
          type="button"
          aria-label="Back to Product Page"
          onClick={() => catalogTabCtx.goCatalog()}
          className="nav-link"
          style={{
            marginRight: "auto",
            position: "absolute",
            left: "-7%",
            zIndex: "6666",
            cursor: "pointer",
            background: "none",
            border: "none",
            padding: 0,
          }}
        >
          <div className="option__icon back__icon2 back__icon__product2" />
        </button>
      ) : (
        <Back2
          header={"Back to Product Page"}
          style={{
            marginRight: "auto",
            position: "absolute",
            left: "-7%",
            zIndex: "6666",
            cursor: "pointer",
          }}
          to={"/product"}
        />
      )}
      {!hideDelete && userAccess === "write" && (
        <div
          className="productdetail__option"
          style={{
            position: "absolute",
            right: "-0.7%",
            top: "-33px",
          }}
        >
          <Delete
            header={"Delete"}
            style={"product"}
            click={handleDelete}
            customStyle={{ width: "7vw", height: "4vw" }}
            customIconStyle={"custom-delete-product"}
          />
        </div>
      )}
      <div
        style={{
          display: "flex",
          position: "relative",
          marginBottom: "50px",
          gap: "20px",
          width: "100%",
        }}
      >
        <EditableProductComponent
          name={name}
          setName={setName}
          productNum={productNum}
          setProductNum={setProductNum}
          variationValues={variations}
          subgroup={subgroupName}
          customHeight={"100%"}
        />

        <div
          style={{
            display: "flex",
            marginBottom: "33.71px",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <ProductIntro />
          <ProductImages productId={productId} />
        </div>
      </div>

      <div style={{ display: "flex", gap: "15px" }}>
        <div style={{ maxWidth: "70vw" }}>
          <div style={{ position: "relative", marginBottom: "50px" }}>
            <ProductBar subgroup={subgroupName} variationItems={variations} />
          </div>

          <ProductMultipleInputs
            label={t("COUNTRY_MANUFACTURING_ASSEMBLY")}
            data={dataCountry}
            isSecondData={true}
          />
          <ProductMultipleInputs
            label={t("IS_PRODUCTS_SOLD")}
            data={dataIsProduct}
          />
          <ProductMultipleInputs
            label={`${t("DEFINE_FUNCTIONAL_UNIT")}`}
            data={dataFunctionalUnit}
          />
          <ProductMultipleInputs
            label={t("QTY_SOLD_FUNCTIONAL_UNIT")}
            data={dataQtyFUSLT}
          />

          <ProductMultipleInputs
            label={`${t("WEIGHT_INDIVIDUAL_PRODUCT")}`}
            data={dataIndividualProduct}
            isSecond={true}
            secondLabel={t("YOUR_WEIGH_IN")}
            secondData={dataWeighIn}
            isError={individualProduct !== finalWeight}
            errorText={
              "Your weigh in needs to be the same as the calculated total individual components"
            }
            customStyling={{ paddingBottom: "8.5px" }}
            firstAdditional1stLabel={"Waste"}
            secondAdditional1stLabel={"Total"}
          />
          <ProductMultipleInputs
            label={`${t("WEIGHT_INDIVIDUAL_PRODUCT_PACKAGING")}*`}
            data={dataWeightIndividualProduct}
            customLabelStyle={{ maxWidth: "200px" }}
          />
          {productData !== null && Object.keys(productData)?.length > 0 && (
            <ProductCertificatesAutocomplete
              certificates={certificates}
              handleCertificatesChange={handleCertificatesChange}
            />
          )}
          <ProductMultipleInputs
            label={`${t("SHARE_PRODUCTS_SOLD")}*`}
            data={dataSaleShare}
            customLabelStyle={{ maxWidth: "200px" }}
          />
          <ProductVariationEditor
            initialProduct={productData}
            onUpdate={handleUpdateVariations}
            subgroups={subgroups}
          />
          <div
            style={{ position: "absolute", bottom: "0%", left: "-0.25%" }}
            onClick={handleUpdateProduct}
          >
            <img src={saveIcon} alt="Save Button" width={25} height={25} />
          </div>
        </div>
        <div
          style={{ display: "flex", flexDirection: "column", maxWidth: "30vw" }}
        >
          <MaterialBreakdownPie productId={productId} />
          <PercentageBreakdownPie productId={productId} />
          {showCategory && (
            <>
              <WeightCategoryPie productId={productId} />
              <PercentageCategoryPie productId={productId} />
            </>
          )}
        </div>
      </div>

      <AlertV2
        open={deleteProductAlert}
        title={t("DELETE_PRODUCT_2")}
        accept={() => {
          deleteProduct({ id: productId, business: business });

          // if it success
          handleMove();
        }}
        decline={() => setDeleteProductAlert(false)}
      />
    </div>
  );
};
